import { render, staticRenderFns } from "./DeliveryNoticeEdit.vue?vue&type=template&id=70f738b8&scoped=true&"
import script from "./DeliveryNoticeEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoticeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f738b8",
  null
  
)

export default component.exports